export const getShowMessagesScript = () => `<script id="show-messages-script">
document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('form');
    forms.forEach((form, index) => {
        const successMessage = form.querySelector('.form-success-message')?.cloneNode(true);
        const alreadySubscribedMessage = form.querySelector('.form-failure-message')?.cloneNode(true);
        if (successMessage || alreadySubscribedMessage) {
            function onSubmit(e) {
                e.preventDefault();
                fetch(form.action, {
                    method: form.method,
                    body: new FormData(form)
                })
                .then(response => response.text())
                .then(data => {
                    if (data.includes("AlreadySubscribed")) {
                        form.after(alreadySubscribedMessage.firstChild);
                        form.remove();
                    } else if (data.includes('Submitted')) {
                        form.after(successMessage.firstChild);
                        form.remove();
                    }
                })
                .catch(error => console.error('Error:', error));
            }
            form.addEventListener('submit', onSubmit);
        }
    });
});
</script>`;

